(() => {
  let adding = false;
  const root = () => window.Shopify.routes.root;
  const isAddon = item => item.properties?._mirancle_addon === 'misty-pet-v1';
  const hasParent = cart => cart.items.some(item => String(item.product_id) === '10475632656721');
  const request = async (path, body) => {
    const response = await fetch(root() + path, {
      method: body ? 'POST' : 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message);
    return data;
  };
  const refreshCart = () => new Promise(resolve => {
    const timer = setTimeout(() => {
      document.removeEventListener('cart:rendered', done);
      window.location.assign(root() + 'cart');
      resolve();
    }, 6000);
    function done() {
      clearTimeout(timer);
      document.removeEventListener('cart:rendered', done);
      resolve();
    }
    document.addEventListener('cart:rendered', done);
    document.dispatchEvent(new CustomEvent('cart:build'));
  });
  class PetAddon extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-addon-add]');
        if (button) this.add(button);
      });
      this.expire = setInterval(() => { if (!(Date.parse(this.dataset.end) > Date.now())) this.hidden = true; }, 30000);
    }
    disconnectedCallback() { clearInterval(this.expire); }
    async add(button) {
      if (adding) return;
      adding = true;
      const status = this.querySelector('[data-addon-status]');
      const controls = [...document.querySelectorAll('mirancle-pet-addon button, mirancle-pet-addon select')];
      controls.forEach(control => { control.disabled = true; });
      status.textContent = '';
      let submitted = false;
      try {
        if (!(Date.parse(this.dataset.end) > Date.now())) throw new Error(this.dataset.unavailable);
        const before = await request('cart.js');
        if (before.currency !== 'USD') throw new Error(this.dataset.unavailable);
        if (before.items.some(isAddon)) throw new Error(this.dataset.duplicate);
        const variant = button.closest('.mirancle-addon__option').querySelector('select').value;
        const items = [{ id: variant, quantity: 1, properties: { _mirancle_addon: 'misty-pet-v1' } }];
        if (this.dataset.context === 'product') {
          const form = document.getElementById(this.dataset.formId);
          const data = form && new FormData(form);
          const id = data?.get('id');
          const quantity = Number(data?.get('quantity') || 1);
          if (!id || !Number.isInteger(quantity) || quantity < 1 || form.querySelector('[data-add-to-cart]')?.disabled) throw new Error(this.dataset.unavailable);
          items.unshift({ id, quantity });
        } else if (!hasParent(before)) {
          throw new Error(this.dataset.parent);
        }
        await request('cart/add.js', { items });
        submitted = true;
        const after = await request('cart.js');
        const added = after.items.find(item => isAddon(item) && String(item.variant_id) === variant);
        if (!added || added.quantity !== 1 || added.final_line_price !== 1490 || !hasParent(after)) {
          if (added && added.quantity === 1) await request('cart/change.js', { id: added.key, quantity: 0 });
          throw new Error(this.dataset.unavailable);
        }
        if (this.dataset.context === 'product' && window.theme.settings.cartType === 'page') {
          window.location.assign(root() + 'cart');
          return;
        }
        await refreshCart();
        document.querySelectorAll('mirancle-pet-addon').forEach(offer => { offer.hidden = true; });
        status.textContent = this.dataset.added;
        if (window.theme.settings.cartType === 'drawer') document.dispatchEvent(new CustomEvent('cart:open'));
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        if (submitted) {
          await refreshCart();
          const current = document.querySelector('mirancle-pet-addon [data-addon-status]');
          if (current) current.textContent = error.message || this.dataset.error;
        }
      } finally {
        adding = false;
        controls.forEach(control => { control.disabled = false; });
      }
    }
  }
  customElements.define('mirancle-pet-addon', PetAddon);
})();
